const OPTIMIZE_CONTAINER_ID =
  process.env.REACT_APP_GOOGLE_OPTIMIZE_CONTAINER_ID || ''

const initializeGoogleOptimize = () => {
  const optimizeElement = document.createElement('script')
  optimizeElement.src = `https://www.googleoptimize.com/optimize.js?id=${OPTIMIZE_CONTAINER_ID}`
  document.head.insertBefore(optimizeElement, document.head.childNodes[0])
}

export { initializeGoogleOptimize }
